// extracted by mini-css-extract-plugin
export default {"container":"modalAccept_container__mtCoy","wrapper":"modalAccept_wrapper__YeP0p","title":"modalAccept_title__Tl3v8","question":"modalAccept_question__1I2+s"};